var _style, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadingInlineAnimation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n@keyframes a0_t { 0% { transform: translate(10px,10px) rotate(0deg) translate(-10px,-10px); } 100% { transform: translate(10px,10px) rotate(360deg) translate(-10px,-10px); } }\n    ")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10,10) translate(-10,-10)",
    style: {
      animation: "1s linear infinite both a0_t"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    stroke: "none",
    fill: "none",
    strokeWidth: 0,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(4.5,4.5) translate(-4.5,-4.5)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10,17C6.13401,17,3,13.866,3,10C3,6.13401,6.13401,3,10,3C13.866,3,17,6.13401,17,10",
    stroke: "#1B202C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(10,10) translate(-10,-10)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingInlineAnimation);
export default __webpack_public_path__ + "static/media/loading-inline-animation.093c42dd98a798f7c45e5bd0423ebdf7.svg";
export { ForwardRef as ReactComponent };